import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../../theme'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'column',
        width: '100%',
    },
    flexDirectionRow: {
        flexDirection: 'row',
    },
    containerItem: {
        flex: 1,
        flexDirection: 'row',
        paddingRight: 10,
    },
    image: {
        marginLeft: 15,
        width: 80,
        height: 80,
        borderRadius: 5,
    },
    containerData: {
        flex: 1,
        alignItems: 'flex-start',
        justifyContent: 'center',
    },
    containerMiniButton: {
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: 15,
    },
    miniButton: {
        flexDirection: 'row',
        width: 72,
        borderWidth: 2,
        borderRadius: 5,
        borderColor: theme.colors.colorPrimary,
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
        marginVertical: 4,
        paddingVertical: 4,
        paddingHorizontal: 4,
    },
    textMiniButton: {
        fontSize: 11,
        fontWeight: 'bold',
        color: theme.colors.colorPrimary,
    },
    title: {
        fontSize: 15,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        textAlign: 'left',
        paddingHorizontal: 15,
        //marginBottom: 'auto',
    },
    description: {
        fontSize: 18,
        color: theme.colors.textSecondary,
        fontWeight: 'bold',
        textAlign: 'left',
        paddingBottom: 5,
        paddingHorizontal: 15,
        //marginTop: 'auto',
    },
    containerAnswer: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: 15,
        justifyContent: 'flex-end',
    },
    answerText: {
        fontSize: 20,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
    },
    containerNa: {
        width: 66,
        height: 26,
        marginTop: 6,
    },
    imageNa: {
        width: 66,
        height: 26,
    },
    containerInput: {
        marginEnd: 12,
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputBlock: {
        flexDirection: 'row',
        width: '100%',
        height: 35,
        borderWidth: 1,
        borderRadius: 10,
        borderColor: theme.colors.lightGray,
        backgroundColor: 'white',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 10,
        marginTop: 5,
        marginBottom: 0,
    },
    input: {
        width: width - 30,
        height: 40,
        borderWidth: 0.2,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        paddingVertical: 10,
        paddingHorizontal: 10,
        marginHorizontal: 0,
        marginBottom: 5,
        alignItems: 'center',
        fontSize: 15,
        color: theme.colors.textPrimary,
    },
    buttonContainer: {
        flexDirection: 'column',
        width: '100%',
        paddingVertical: 5,
    },
    borderButton: {
        borderWidth: 2,
        borderColor: theme.colors.colorPrimary,
        paddingVertical: 8,
        paddingHorizontal: 50,
        marginHorizontal: 15,
        marginBottom: 15,
        borderRadius: 10,
    },
    borderButtonText: {
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
        fontSize: 15,
        textAlign: 'center',
    },
    dividerHorizontalLine: {
        width: '100%',
        borderBottomWidth: 0.5,
        borderBottomColor: theme.colors.lightGray,
        marginVertical: 10,
    },
    marginLeft: {
        marginLeft: 4,
    },
})

export default styles
